import { ACTION_TYPES } from '../../utils/Constants';

let intialState = {
    previousSession: [],
    todaySession: [],
    upcomingSession: [],
    manageSchedule: [],
    waitingRoom: [],
};

const DashBoardPatientReducer = (state = intialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.PATIENT.DASHBOARD:
            state = {
                ...state,
                previousSession: action.payload.previousSession,
                manageSchedule: action.payload.manageSchedule,
                upcomingSession: action.payload.upcomingSession,
            };
            break;
        case ACTION_TYPES.PATIENT.DASHBOARD_APPOINTMENT:
            return {
                ...state,
                todaySession: action.payload,
            };
        default:
            break;
    }
    return state;
};
export default DashBoardPatientReducer;
